module.exports = __webpack_public_path__ + "img/c1.cb5be4f1.svg";